import { defineRulesFor, updateAbility } from 'utils/can';
import { setWindowUser } from 'utils/hooks/storage/storageSets';

import { getParams } from './companies';

export const url_users = {
	auth_token: 'users/auth/token/',
	revoke_token: 'users/auth/revoke-token/',
	supplier: 'users/suppliers/',
	reset_pin_step1: 'users/reset-pin/step1/',
	reset_pin_step2: 'users/reset-pin/step2/',
	reset_pin_step3: 'users/reset-pin/step3/',
	reset_pin_step4: 'users/reset-pin/step4/',
	reset_pin_step5: 'users/reset-pin/step5/',
	send_personal_suppliers_mail: 'users/send-personal-suppliers-mail/',
	send_suppliers_mail: 'users/send-suppliers-mail/',
	suppliers: 'users/suppliers/',
	send_message: 'users/send-message/',
	data: 'users/data/',
	auth_change_password: 'users/auth/change-password/',
	update: 'users/profile/',
	set_agreement: 'users/set-agreement/'
};

const user = service => ({
	getCertificates: () => service.get('/users/profile/certificates/'),
	addCertificates: ({ certFile, keyFile, bank, type, purpose }, companySlug = null) => {
		const formData = new FormData();

		formData.append('certificate', certFile, certFile.name);
		formData.append('private_key', keyFile, keyFile.name);
		if(bank) {
			formData.append('bank', bank);
		}
		if(purpose) {
			formData.append('purpose', purpose);
		}
		formData.append('type', type);

		if(companySlug) {
			formData.append('company', companySlug);
		}

		return service.post('/users/profile/certificates/', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	},
	updateUser: ({ slug, ...values }) => service.patch(`/users/${slug}/`, values),
	addUser: (values) => service.post('/users/person/create/', values),
	getUser: (slug) => service.get(`/users/person/${slug}/`),
	getSupplierUser: (slug) => service.get(`/users/suppliers/${slug}/`),
	setBlocked: (slug, shouldBlock) => service.patch(`/users/person/${slug}/`, { isActive: !shouldBlock }),
	getUsersList: ({ page, rowsPerPage, searchParameter, sortParameter, isOrderByAsc }) => {
		return service.get('users/person/list/', {
			params: {
				...getParams({ page, rowsPerPage, searchParameter, sortParameter, isOrderByAsc }),
			}
		});
	},

	resetPinStepPersonalData: ({ phoneCountryPrefix, phoneNumber, companyNip }) => service.post(url_users.reset_pin_step1, {
		phoneCountryPrefix,
		phoneNumber,
		companyNip
	}),
	resetPinStepSendSms: ({ userSlug, ...params }) => service.post(url_users.reset_pin_step2, {
		user: userSlug,
		...params
	}),
	resetPinStepSendOtpCode: ({ userSlug, companySlug, otp }) => service.post(url_users.reset_pin_step3, {
		user: userSlug,
		company: companySlug,
		otp
	}),
	resetPinStepSendQuestions: ({ userSlug, companySlug, otp, questions }) => service.post(url_users.reset_pin_step4, {
		questions: { ...questions },
		user: userSlug,
		company: companySlug,
		otp
	}),
	resetPinStepReauthorizeUser: ({ userSlug }) => service.post(url_users.reset_pin_step5, {
		user: userSlug
	}),
	sendPersonalSuppliersInCompaniesInvitationMails: ({ values }) => service.post(url_users.send_personal_suppliers_mail, values),
	sendNationalInvoiceRegistry: ({ values }) => service.post(url_users.send_personal_suppliers_mail, values),
	sendSuppliersInvitationMails: ({ values }) => service.post(url_users.send_suppliers_mail, values),
	updateCompanySupplier: ({ values: { slug, ...values } }) => service.patch(`${url_users.supplier}${slug}/`, values),
	getCompanySupplier: ({ slug }) => service.get(`${url_users.supplier}${slug}/`),
	getSuppliers: ({ page, rowsPerPage, sortParameter, isOrderByAsc, searchParameter, status, statusIn, havePhone }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;

		const pagination = Object.assign({},
			order && { o: order },
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		const otherParams = Object.assign({},
			searchParameter && { q: searchParameter },
			status !== -1 && { status },
			statusIn && { statusIn },
			havePhone !== undefined && { havePhone }
		);

		return service.get(url_users.suppliers, {
			params: {
				...pagination,
				...otherParams
			}
		});
	},
	sendMessage: values => service.post(url_users.send_message, {
		...values,
		browserDetails: JSON.stringify({
			document: window.document,
			location: window.location,
			navigator: window.navigator,
			performance: window.performance,
			screen: window.screen
		})
	}),

	resetPassword: ({ oldPassword, newPassword }) => service.put(url_users.auth_change_password, { oldPassword, newPassword }),
	changeAgreementContext: slug => service.put(url_users.set_agreement, { slug }),
	initUserData: async () => {
		const response = await service.get(url_users.data);
		updateAbility(defineRulesFor(response.data));
		setWindowUser(response.data);
		return response;
	},
	update: async values => {
		const response = await service.patch(url_users.update, values);
		updateAbility(defineRulesFor(response.data));
		return response;
	}
});

export default user;
